// extracted by mini-css-extract-plugin
module.exports = {"container":"SDKPage-container-2BgE7P"};